export function convertMetricToImperialTemp(temp) {
  return (temp * 9) / 5 + 32;
}

export function convertImperialToMetricTemp(temp) {
  return ((temp - 32) * 5) / 9;
}
